import React from 'react';
import { Link } from 'react-router-dom';
import './StoreState.css';

export function StoreLoading({ label = 'Loading…', skeletons = 0 }) {
  return (
    <div className="store-state" role="status" aria-live="polite">
      <p className="store-state-label">{label}</p>
      {skeletons > 0 && (
        <div className="store-skeleton-grid" aria-hidden="true">
          {Array.from({ length: skeletons }, (_, index) => (
            <div key={index} className="store-skeleton" />
          ))}
        </div>
      )}
    </div>
  );
}

export function StoreEmpty({
  eyebrow = 'Nothing here',
  title,
  lede,
  actionLabel = 'Browse the shop',
  actionTo = '/shop',
}) {
  return (
    <div className="store-state store-state--empty">
      {eyebrow && <p className="store-eyebrow">{eyebrow}</p>}
      {title && <h2 className="store-state-title">{title}</h2>}
      {lede && <p className="store-lede">{lede}</p>}
      {actionTo && (
        <Link to={actionTo} className="store-btn">
          {actionLabel}
        </Link>
      )}
    </div>
  );
}

export function StoreError({ message, onRetry }) {
  return (
    <div className="store-state store-state--error" role="alert">
      <p className="store-state-title">Something went wrong</p>
      <p className="store-lede">{message || 'Please try again.'}</p>
      {onRetry && (
        <button type="button" className="store-btn" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}
